module.exports = __webpack_public_path__ + "static/media/mr-aladin.dbb2ac01.png";